import React from 'react';
import { Loader2 } from 'lucide-react';

const Spinner: React.FC<{ fullScreen?: boolean }> = ({ fullScreen }) => (
  <div
    className={
      fullScreen
        ? 'min-h-screen flex items-center justify-center text-ink-muted'
        : 'flex items-center justify-center py-24 text-ink-muted'
    }
  >
    <Loader2 className="w-6 h-6 animate-spin" />
  </div>
);

export default Spinner;
